import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import range from 'js-range';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { changeStepOfProfessionalSolution } from '../../../../../../actions/ProfessionalSolutionActions';
import { propFunc, propNumber, } from '../../../../../../helpers/custom-prop-types';
import CheckedStep from './CheckedStep';
import CurrentStep from './CurrentStep';
import RemainingStep from './RemainingStep';
const StepMenu = ({ changeStep, current, max }) => (_jsx("div", Object.assign({ className: 'step-menu' }, { children: _jsx("ol", Object.assign({ className: 'step-menu-list' }, { children: range(1, max + 1).map((step) => (_jsxs("li", { children: [step < current && (_jsx(CheckedStep, { changeStep: () => changeStep(step) })), step === current && _jsx(CurrentStep, {}), current < step && _jsx(RemainingStep, {})] }, `step-menu[${step}]`))) })) })));
StepMenu.propTypes = {
    changeStep: propFunc().isRequired,
    current: propNumber().isRequired,
    max: propNumber().isRequired,
};
const mapDispatchToProps = (dispatch) => ({
    changeStep: (step) => dispatch(changeStepOfProfessionalSolution(step)),
});
const enhance = compose(connect(null, mapDispatchToProps));
export default enhance(StepMenu);
